import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoanLayoutComponent } from "./loan-layout.component";
import { dashboardDetailsGuard } from "../shared/guards/dashboardDetails.guard";
import { EmiSummaryComponent } from "./components/loan-dashboard/components/re-payment/component/emi-summary/emi-summary.component";
import { RepaySuccessfulComponent } from "./components/loan-dashboard/components/re-payment/component/repay-successful/repay-successful.component";
import { InfoErrorComponent } from "../shared/components/info-error/info-error.component";
import { TakePictureComponent } from "./components/take-picture/take-picture.component";
import { KycNeededComponent } from "./components/loan-dashboard/components/aadhaar-kyc/components/kyc-needed/kyc-needed.component";

const routes: Routes = [
    {
        path: "",
        redirectTo: "/",
        pathMatch: "full",
    },
    {
        path: "",
        component: LoanLayoutComponent,
        children: [
            {
                path: "",
                loadChildren: () =>
                    import("./components/loan-dashboard/loan-dashboard.module").then((m) => m.LoanDashboardModule),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "change-current-address",
                loadChildren: () =>
                    import("./components/loan-dashboard/components/change-current-address/change-current-address.module").then(
                        (m) => m.ChangeCurrentAddressModule
                    ),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "employment",
                loadChildren: () =>
                    import("./components/employment-verification/employment-verification.module").then(
                        (m) => m.EmploymentVerificationModule
                    ),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "purpose-of-loan",
                loadChildren: () =>
                    import("./components/purpose-of-loan/purpose-of-loan.module").then((m) => m.PurposeOfLoanModule),
            },
            {
                path: "soft-approval",
                loadChildren: () =>
                    import("./components/soft-approval/soft-approval.module").then((m) => m.SoftApprovalModule),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "net-banking",
                loadChildren: () =>
                    import("./components/net-banking/net-banking.module").then((m) => m.NetBankingModule),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "kyc",
                loadChildren: () => import("./components/kyc/kyc.module").then((m) => m.KycModule),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "user-approval",
                loadChildren: () =>
                    import("./components/user-approval/user-approval.module").then((m) => m.UserApprovalModule),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "bank-verification",
                loadChildren: () =>
                    import("./components/bank-verification/bank-verification.module").then(
                        (m) => m.BankVerificationModule
                    ),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "profile-verification",
                loadChildren: () =>
                    import("./components/profile-details-verification/profile-details-verification.module").then(
                        (m) => m.ProfileDetailsVerificationModule
                    ),
                canActivate: [dashboardDetailsGuard],
            },

            {
                path: "c-kyc",
                loadChildren: () => import("./components/c-kyc/c-kyc.module").then((m) => m.CKycModule),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "e-sign",
                loadChildren: () => import("./components/e-sign/e-sign.module").then((m) => m.ESignModule),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "e-mandate",
                loadChildren: () => import("./components/e-mandate/e-mandate.module").then((m) => m.EMandateModule),
                canActivate: [dashboardDetailsGuard],
            },
            {
                path: "loan-declined",
                loadChildren: () =>
                    import("./components/loan-decline/loan-decline.module").then((m) => m.LoanDeclineModule),
            },
            {
                path: "contact-us",
                loadChildren: () => import("./components/contact-us/contact-us.module").then((m) => m.ContactUsModule),
            },
            {
                path: "disbursement",
                loadChildren: () =>
                    import("./components/disbursement/disbursement.module").then((m) => m.DisbursementModule),
            },
            {
                path: "emi-summary",
                component: EmiSummaryComponent,
            },
            { path: "repay-successful", component: RepaySuccessfulComponent },
            { path: "info", component: InfoErrorComponent },
            { path: "re-take-picture", component: TakePictureComponent },
            { path: "kyc-needed", component: KycNeededComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LoanLayoutRoutingModule {}
